import { FormGroup, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import type { FormEvent } from 'react';
import { post, put } from 'helpers/api';
import ErrorAlert from '../../../project/components/new_listing_modal/error_alert';
import Button from 'shared/button';

type EditModalProps = {
  id: string | number;
  title?: string;
  onCloseModal: () => void;
  onSuccessfulFormSubmit: (result: any) => void;
};

export default function EditModal(props: EditModalProps) {
  const [inputTitle, setInputTitle] = useState<string>(props.title || '');
  const [errors, setErrors] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const canSubmitForm = inputTitle.length > 0;

  async function submitForm(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!canSubmitForm) {
      return;
    }

    setIsSubmitting(true);
    setErrors([]);

    const { fetchMethod, url } = fetchParams();
    try {
      const subSpecialtyArguments = { title: inputTitle };
      const res = await fetchMethod(url, { sub_specialty: subSpecialtyArguments });
      setIsSubmitting(false);
      if (res.id) {
        props.onSuccessfulFormSubmit(res);
      } else {
        setErrors(res);
      }
    } catch {
      setIsSubmitting(false);
      const uploadType = props.id === '' ? 'created' : 'updated';
      setErrors([`Sub-specialty could not be ${uploadType}. Please try again or contact support for help.`]);
    }
  }

  function fetchParams() {
    if (props.id === '') {
      return { fetchMethod: post, url: '/sub_specialties' };
    }
    return { fetchMethod: put, url: `/sub_specialties/${props.id}` };
  }

  return (
    <Modal.Body className="p-5">
      <h2 className="text-center mt-0 mb-4">{props.id === '' ? 'Add a' : 'Edit'} Sub-specialty</h2>
      <ErrorAlert errorMessages={errors} hasErrors={errors.length > 0}/>
      <form onSubmit={submitForm}>
        <FormGroup>
          <label htmlFor="sub-specialty-title">Add Sub-specialty Title</label>
          <input
            autoFocus
            className="form-control"
            id="sub-specialty-title"
            placeholder="Enter sub-specialty title"
            value={inputTitle}
            onChange={e => setInputTitle(e.target.value)}
          />
        </FormGroup>

        <div className="mt-5 d-flex gap-3">
          <Button.Cancel
            disabled={isSubmitting}
            type="button"
            onClick={props.onCloseModal}
          >
            Cancel
          </Button.Cancel>
          <Button.Primary disabled={!canSubmitForm || isSubmitting} type="submit">
            {props.id === '' ? 'Add' : 'Update'} Sub-specialty
          </Button.Primary>
        </div>
      </form>
    </Modal.Body>
  );
}